<template>
  <footer class="maix-footer" aria-hidden="true">
    <div class="maix-line"></div>

    <span class="maix-logo">
      MA<span class="maix-i">i</span>X
    </span>

    <div class="maix-line"></div>
  </footer>
</template>

<script>
export default {
  name: "MaixFooter"
};
</script>

<style scoped>
.maix-footer {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 60px 0 54px;
}

.maix-line {
  flex: 1;
  height: 1px;
  background: #e5e9e6;
}

.maix-logo {
  color: #b4bdb8;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.28em;
  user-select: none;
}

.maix-i {
  color: #18ab69;
}
</style>
